import { Link, useParams, Navigate } from 'react-router-dom';
import { Phone } from 'lucide-react';
import { Button } from '../../components/ui/button';
import SEO from '../../components/SEO';
import { simpleServices } from '../../data/simpleServices';

export default function SimpleServicePage() {
  const { slug } = useParams();
  const service = simpleServices.find((s) => s.slug === slug);

  if (!service) return <Navigate to="/mens-health" replace />;

  const { name, label } = service;

  return (
    <div className="pb-20 md:pb-0" data-testid="simple-service-page">
      <SEO
        title={`${label} | Havkin Urology Melbourne FL`}
        description={`Havkin Urology specializes in ${name} urology. ${name} treatment in Melbourne, Florida by Dr. Boris Havkin. Call (321) 500-4545.`}
        keywords={`${name}, ${name} treatment, ${name} Melbourne FL, urologist, Dr. Havkin`}
        canonical={`/services/${slug}`}
      />

      <div className="bg-slate-50 border-b border-slate-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <nav className="flex items-center text-sm text-slate-500">
            <Link to="/" className="hover:text-black">Home</Link>
            <span className="mx-2">/</span>
            <Link to="/mens-health" className="hover:text-black">Services</Link>
            <span className="mx-2">/</span>
            <span className="text-primary">{label}</span>
          </nav>
        </div>
      </div>

      <section className="py-12 md:py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6" data-testid="service-title">
              {label}
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed" data-testid="service-description">
              Havkin Urology specializes in {name} urology. Our {name} treatment in Melbourne, Florida is geared to help answer any questions you have regarding {name}. Our {name} doctor, Dr. Boris Havkin, is here to answer any questions you have. Call Havkin Urology today to learn more.
            </p>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-black text-center" data-testid="service-cta">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading text-2xl font-bold text-white mb-4">
            Schedule a Consultation
          </h2>
          <p className="text-gray-300 mb-8">
            Contact Dr. Boris Havkin to discuss your {name} concerns in a confidential setting.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-white text-black hover:bg-gray-200 rounded-full px-8" data-testid="service-appointment-btn">
              <Link to="/contact">Request Appointment</Link>
            </Button>
            <a
              href="tel:+13215004545"
              className="inline-flex items-center justify-center px-8 py-3 border-2 border-white text-white rounded-full font-medium hover:bg-white/10"
              data-testid="service-call-btn"
            >
              <Phone className="h-5 w-5 mr-2" />
              (321) 500-4545
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
